import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { useStreamChatContext } from '../utils/utils';

const defaultBodyMessage = 'We\'ve made sharing files easy! Just click the + button next to \'Send\n'
    + '        message\' to add attachments to your messages. This feature lets you\n'
    + '        safely share documents, images and videos while keeping our platform\n'
    + '        secure.';

const DisintermediationModal = ({ toggleModal, ...props }) => {
  const closeModal = () => {
    toggleModal('');
  };

  const { bookingId, ssoId } = useStreamChatContext();

  const onSupportClicked = () => {
    analytics.track('clicked_contact_from_email_block_notification', {
      bookingId,
      ssoId
    });
  };

  return (
    <BootstrapModal
      {...props}
      onClose={closeModal}
      modalSize="sm-size"
      modalClass="disintermediation-modal"
      header={
        <div className="text-center">
          <h3>
            <FormattedMessage id="inbox.disintermediation_modal.title"
              defaultMessage={'Don\'t share your contact information here'} />
          </h3>
        </div>
      }
      body={
        <div className="text-center">
          <p>
            <FormattedMessage id="inbox.disintermediation_modal.body"
              defaultMessage={defaultBodyMessage} />
          </p>
          <div>
            <p>
              <FormattedMessage id="inbox.disintermediation_modal.need_help" defaultMessage="Need help?" />
              {' '}
              <a
                href="https://support.peerspace.com/hc/en-us/requests/new"
                target="_blank"
                className="underline"
                onClick={onSupportClicked}
                rel="noreferrer"
              >
                <FormattedMessage id="inbox.disintermediation_modal.contact_support"
                  defaultMessage="Get in touch with support" />
              </a>
            </p>
          </div>
        </div>
      }
    />
  );
};

DisintermediationModal.propTypes = {
  toggleModal: PropTypes.func.isRequired,
  intl: intlShape.isRequired
};

export default injectIntl(DisintermediationModal);
